import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';

function RedefinirSenha() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [erros, setErros] = useState({});
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(event) {
    event.preventDefault();

    const novosErros = {};
    if (!novaSenha) novosErros.novaSenha = 'Nova senha é obrigatória';
    else if (novaSenha.length < 6) novosErros.novaSenha = 'Mínimo 6 caracteres';
    if (!confirmarSenha) novosErros.confirmarSenha = 'Confirme a nova senha';
    else if (novaSenha !== confirmarSenha) novosErros.confirmarSenha = 'Senhas não conferem';

    if (Object.keys(novosErros).length > 0) {
      setErros(novosErros);
      return;
    }

    setErros({});
    setErro('');
    setIsLoading(true);
    try {
      await axios.post(API_BASE_URL.RESET_PASSWORD, { token, novaSenha, confirmarSenha });
      setSucesso(true);
    } catch (error) {
      setErro(error.response?.data?.message || 'Não foi possível redefinir a senha. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundImage: `url('/assets/desktop.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.55)' }} />

      <div
        style={{
          position: 'relative',
          zIndex: 1,
          width: '100%',
          maxWidth: '380px',
          margin: '1rem',
          borderRadius: '16px',
          overflow: 'hidden',
          backgroundColor: '#fff',
          boxShadow: '0 12px 48px rgba(0,0,0,0.5)',
        }}
      >
        <div style={{ backgroundColor: '#198754', padding: '2rem 2rem 1.5rem', textAlign: 'center' }}>
          <img
            src="/assets/logo.png"
            alt="Logo"
            width="64"
            height="64"
            style={{ borderRadius: '12px', marginBottom: '0.75rem' }}
          />
          <h4 style={{ color: '#fff', margin: 0, fontWeight: 700, letterSpacing: '0.5px' }}>
            {sucesso ? 'Senha redefinida' : 'Redefinir senha'}
          </h4>
        </div>

        <div style={{ padding: '2rem' }}>
          {sucesso ? (
            <>
              <div className="alert alert-success d-flex align-items-start gap-2 py-2 mb-3" role="alert" style={{ fontSize: '0.83rem', borderRadius: '8px' }}>
                <i className="bi bi-check-circle-fill flex-shrink-0 mt-1"></i>
                <span>Sua senha foi redefinida com sucesso. Você já pode acessar com a nova senha.</span>
              </div>
              <button type="button" className="btn btn-success w-100" style={{ borderRadius: '8px', padding: '0.6rem', fontWeight: 600 }} onClick={() => navigate('/')}>
                <i className="bi bi-box-arrow-in-right me-2"></i>Ir para o login
              </button>
            </>
          ) : (
            <>
              <p style={{ fontSize: '0.85rem', color: '#6c757d', marginBottom: '1.25rem', textAlign: 'center' }}>
                Escolha uma nova senha para o seu acesso.
              </p>

              {erro && (
                <div className="alert alert-danger d-flex align-items-start gap-2 py-2 mb-3" role="alert" style={{ fontSize: '0.83rem', borderRadius: '8px' }}>
                  <i className="bi bi-exclamation-triangle-fill flex-shrink-0 mt-1"></i>
                  <span>{erro}</span>
                </div>
              )}

              {!token && (
                <div className="alert alert-warning d-flex align-items-start gap-2 py-2 mb-3" role="alert" style={{ fontSize: '0.83rem', borderRadius: '8px' }}>
                  <i className="bi bi-exclamation-triangle-fill flex-shrink-0 mt-1"></i>
                  <span>Link inválido: o token de recuperação não foi informado.</span>
                </div>
              )}

              <form onSubmit={handleSubmit} autoComplete="off">
                <div className="mb-3">
                  <label style={{ fontSize: '0.82rem', fontWeight: 600, marginBottom: '0.4rem', display: 'block', letterSpacing: '0.5px' }}>
                    <i className="bi bi-lock me-2"></i>NOVA SENHA
                  </label>
                  <input
                    type="password"
                    className={`form-control${erros.novaSenha ? ' is-invalid' : ''}`}
                    placeholder="Digite a nova senha"
                    value={novaSenha}
                    onChange={e => setNovaSenha(e.target.value)}
                    required
                    disabled={!token || isLoading}
                    style={{ borderRadius: '8px', padding: '0.6rem 0.9rem' }}
                  />
                  {erros.novaSenha && <div className="invalid-feedback">{erros.novaSenha}</div>}
                </div>

                <div className="mb-3">
                  <label style={{ fontSize: '0.82rem', fontWeight: 600, marginBottom: '0.4rem', display: 'block', letterSpacing: '0.5px' }}>
                    <i className="bi bi-lock-fill me-2"></i>CONFIRMAR NOVA SENHA
                  </label>
                  <input
                    type="password"
                    className={`form-control${erros.confirmarSenha ? ' is-invalid' : ''}`}
                    placeholder="Confirme a nova senha"
                    value={confirmarSenha}
                    onChange={e => setConfirmarSenha(e.target.value)}
                    required
                    disabled={!token || isLoading}
                    style={{ borderRadius: '8px', padding: '0.6rem 0.9rem' }}
                  />
                  {erros.confirmarSenha && <div className="invalid-feedback">{erros.confirmarSenha}</div>}
                </div>

                <button
                  type="submit"
                  className="btn btn-success w-100"
                  disabled={isLoading || !token}
                  style={{ borderRadius: '8px', padding: '0.6rem', fontWeight: 600 }}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" />
                      Salvando...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-check2-circle me-2"></i>Redefinir senha
                    </>
                  )}
                </button>
              </form>

              <div style={{ marginTop: '1rem', textAlign: 'center' }}>
                <button type="button" className="btn btn-link" onClick={() => navigate('/')}>
                  Voltar para o login
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default RedefinirSenha;
